import { render } from "./v-profile-info-item.vue?vue&type=template&id=6ed78972"
import script from "./v-profile-info-item.vue?vue&type=script&lang=js"
export * from "./v-profile-info-item.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__